import type { KambiHistoryCoupon } from '@mobi/api-types/kambi'
import type { BetLoopKambiShareCoupon } from '@core/Areas/BetLoop/types'
import { getKambiCouponBetType } from '@core/Areas/KambiSports/Player/helpers/getKambiCouponBetType'
import type { KambiSportBetDetails } from '@core/Areas/ShareBet/LoadBet/types'
import { LoadBetErrors } from '../constants'

/** Used for Bet Loop & External Share. Expects only singular bet (single, SGM, multi) */
export const createKambiCouponLoadBetDetails = (
  coupon: KambiHistoryCoupon | BetLoopKambiShareCoupon
): KambiSportBetDetails[] => {
  if (coupon.bets.length !== 1) throw new Error(LoadBetErrors.Default)

  const kambiSportBetDetails: KambiSportBetDetails = {
    betSelectionType: getKambiCouponBetType(coupon),
    betOfferIds: coupon.betOffers.map(betOffer => betOffer.betOfferId),
    outcomeIds: coupon.bets[0].couponRowIndexes.flatMap(idx => {
      const couponRow = coupon.couponRows.find(cr => cr.index === idx)
      if (!couponRow) return []
      return [
        couponRow.outcomeGroup
          ? couponRow.outcomeGroup.groups.map(({ outcomeIds }) => outcomeIds).flat()
          : couponRow.outcomeId,
      ]
    }),
    outcomesWithEarlyPayout: coupon.outcomes
      .filter(x => x.outcomeTags?.includes('ELIGIBLE_FOR_EARLY_SETTLEMENT'))
      .map(c => c.outcomeId),
  }

  return [kambiSportBetDetails]
}
